module.exports = __webpack_public_path__ + "static/media/img_welcome.62623c19.jpg";